import React, { useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import './Spinner/Spinner.css';

const Status2FA = ({ twoFactor, onSetStatus, user }) => {
  const [loading, setLoading] = useState(false);
  const canDisable2FA = Boolean(user && user.canDisable2FA);

  const handleChange = async () => {
    if (!canDisable2FA || loading) {
      if (!canDisable2FA) {
        toast.error('User not authorized to perform this action');
      }
      return;
    }
    setLoading(true);
    try {
      await onSetStatus();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {loading ? (
        <div className="loading-btn-spinner" style={{ margin: 0 }} />
      ) : (
        <input
          type="checkbox"
          checked={Boolean(twoFactor)}
          disabled={!canDisable2FA}
          title={twoFactor ? '2FA enabled' : '2FA disabled'}
          aria-label={twoFactor ? '2FA enabled' : '2FA disabled'}
          style={{ cursor: canDisable2FA ? 'pointer' : 'not-allowed' }}
          onChange={handleChange}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
  };
};

export default connect(mapStateToProps)(Status2FA);
